import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';

const RotatingBanner = ({ images = [], customHeight, alignments = [], interval = 5000 }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const theme = useTheme();

  useEffect(() => {
    if (images.length === 0) return;
    
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(intervalId);
  }, [images.length, interval]);

  const handleImageLoad = (image) => {
    setImagesLoaded(prev => ({
      ...prev,
      [image]: true
    }));
  };

  return (
    <Box sx={{ 
      width: '100vw', 
      position: 'relative', 
      left: '50%', 
      right: '50%', 
      ml: '-50vw', 
      mr: '-50vw', 
      height: customHeight || { xs: 176 }, 
      overflow: 'hidden',
      backgroundColor: theme.palette.primary.main
    }}>
      {images.map((image, index) => (
        <Box
          key={image}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: currentImageIndex === index ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: currentImageIndex === index ? 1 : 0,
          }}
        >
          <img
            src={image}
            alt={`Banner ${index + 1}`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: alignments[index] || 'center',
              display: 'block',
              opacity: imagesLoaded[image] ? 1 : 0,
              transition: 'opacity 0.2s ease-in-out',
            }}
            onLoad={() => handleImageLoad(image)}
          />
        </Box>
      ))}
    </Box>
  );
};

export default RotatingBanner; 